import React, { Component } from 'react';

import '../../../styles/UI/Modal.css';

class modal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fadeInClass: ''
        }
        this.resetValues = this.resetValues.bind(this);
    }

    resetValues = () => {
        this.setState({
            fadeInClass: ''
        });
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                fadeInClass: 'fade-scale-in'
            });
        }, 10);
    }

    createOptions = () => {
        if (this.props.options !== undefined) {
            return this.props.options.map((option, index) => {
                return (
                    <span
                        key={index}
                        onClick={this.props.optionSelected.bind(this, index)}
                        className='Modal__Options'>
                        {option}
                    </span >
                )
            })
        }
        else {
            if (this.props.hideFooter) {
                return '';
            }
            else {
                return (
                    <div className='Modal__Buttons__Conainter'>
                        <button
                            onClick={this.props.optionSelected.bind(this, false)}
                            className='Modal__Buttons__Cancel'>
                            {this.props.t('Timesheet.cancel', { framework: "react-i18next" })}
                        </button>
                        <button
                            onClick={this.props.optionSelected.bind(this, true)}
                            className='Modal__Buttons__Accept'>
                            {this.props.t('Timesheet.accept', { framework: "react-i18next" })}
                        </button>
                    </div>
                );
            }
        }
    }

    render() {
        let closeButton = '';
        if (this.props.close !== undefined) {
            closeButton = <span onClick={this.props.close} class="fas fa-times" />
        }
        const extraClass = this.props.className !== undefined ? this.props.className : '';
        return (
            <div className={`Modal__Main__Container fade-scale ${this.state.fadeInClass} ${extraClass}`}>
                {closeButton}
                <div className='Modal__Title'>{this.props.title}</div>
                <div className='Modal__Options__Container'>{this.createOptions(this.props)} </div>
            </div>
        );
    }
}

export default modal;